import "../../../Create/Create.css"
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {restUrl} from "../../../../../apiUrl";
import {partition} from "../../component/AboutPre";

export default function SubmitButton({answers, appId}){
    const nav = useNavigate()
    const onClick = async ()=>{
        let blank;
        const indexes= []
        answers.forEach((it, index) => {
            if(it === ""){
                blank=true
                indexes.push(index)
            }
        })
        if(blank) alert(indexes.map(it=> `${it}번`).join(', ')+" 문제에 답을 입력하지 않았습니다.")
        else {
            if(window.confirm("제출하시겠습니까?")) {
                const a = answers.join(partition)
                await axios.patch(`${restUrl}/activity_test_application?id=eq.${appId}`,{preview_response: a})
                nav(-1)
            }
        }
    }

    return(
        <button onClick={onClick} className="submit blackButton">
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.6458 2.96648C14.0127 2.96648 14.3099 2.66931 14.3099 2.30242V0.665059C14.3099 0.298164 14.0124 0.000996094 13.6458 0.000996094H3.33891C3.3326 0.000996094 3.32662 0 3.32031 0C3.314 0 3.30803 0.000664062 3.30172 0.000996094H1.99219C0.893496 0.000996094 0 0.894492 0 1.99285V15.0078C0 16.1062 0.893496 17 1.99219 17H13.6458C13.6916 17 13.7365 16.9954 13.7796 16.9864C13.9526 16.9509 14.101 16.8483 14.1963 16.7071C14.268 16.6012 14.3099 16.4734 14.3099 16.3359V12.1084C14.3099 11.7415 14.0127 11.4443 13.6458 11.4443C13.2789 11.4443 12.9818 11.7415 12.9818 12.1084V13.016H3.98404V1.32912H12.9818V2.30275C12.9818 2.66964 13.2789 2.96648 13.6458 2.96648ZM1.32812 1.99285C1.32812 1.62662 1.62596 1.32879 1.99219 1.32879H2.65625V13.0156H1.99219C1.75943 13.0156 1.53598 13.0561 1.32812 13.1298V1.99285ZM12.9818 14.3438V15.6719H1.99219C1.62596 15.6719 1.32812 15.374 1.32812 15.0078C1.32812 14.6416 1.62596 14.3438 1.99219 14.3438H12.9818Z"
                    fill="white"/>
                <path
                    d="M17 7.07681C16.9966 6.70415 16.8464 6.34786 16.5821 6.08514L14.2517 3.74764C14.1189 3.61572 13.9394 3.54167 13.7523 3.54167C13.5652 3.54167 13.3856 3.61572 13.2529 3.74764C13.1865 3.81349 13.1338 3.89184 13.0979 3.97815C13.0619 4.06447 13.0434 4.15705 13.0434 4.25056C13.0434 4.34407 13.0619 4.43665 13.0979 4.52297C13.1338 4.60929 13.1865 4.68763 13.2529 4.75348L14.875 6.36847H9.20833C9.02047 6.36847 8.8403 6.4431 8.70747 6.57594C8.57463 6.70878 8.5 6.88894 8.5 7.07681C8.5 7.26467 8.57463 7.44483 8.70747 7.57767C8.8403 7.71051 9.02047 7.78514 9.20833 7.78514H14.875L13.2529 9.40722C13.1195 9.53966 13.0442 9.71967 13.0436 9.90763C13.0429 10.0956 13.1169 10.2761 13.2494 10.4095C13.3818 10.5429 13.5618 10.6182 13.7498 10.6189C13.9378 10.6195 14.1183 10.5455 14.2517 10.4131L16.5821 8.07555C16.8481 7.8111 16.9984 7.45192 17 7.07681Z"
                    fill="white"/>
            </svg>
            제출
        </button>
    )
}